module.exports = __webpack_public_path__ + "img/wechat-tabs1.a8265661.png";